<template>
  <v-container
    id="openEnrollmentSummary"
  >
    <div>
      <div
        v-if="isRenewal"
        class="text-center display-2 font-weight-bold green--text"
      >
        <v-icon
          color="green"
          large
        >
          mdi-refresh
        </v-icon>
        Renewal
      </div>
      <div class="text-center display-2">
        {{ openEnrollment.broker }}
      </div>
      <div class="text-center display-1">
        {{ openEnrollment.groupName }}
      </div>
      <div class="text-center display-1 mb-6">
        {{ openEnrollment.brokerGroupYear }}
      </div>
    </div>
    <div
      class="text-center mb-3"
    >
      <v-btn
        class="mx-2"
        fab
        dark
        x-small
        :color="percentColor(openEnrollment.approvedPercent)"
        @click="toggleExpanded"
      >
        <v-icon
          v-show="!expanded"
          dark
        >
          mdi-arrow-expand-vertical
        </v-icon>
        <v-icon
          v-show="expanded"
          dark
        >
          mdi-arrow-expand-horizontal
        </v-icon>
      </v-btn>
    </div>
    <v-progress-linear
      v-model="openEnrollment.approvedPercent"
      :color="percentColor(openEnrollment.approvedPercent)"
      height="15"
      rounded
    >
      <template v-slot="{ value }">
        <strong>{{ Math.ceil(value) }}% Approvals</strong>
      </template>
    </v-progress-linear>
    <group-summary
      class="oe-summary-section"
      :expanded="expanded"
      :details="openEnrollment"
      :group-id="openEnrollment.groupId"
      @approval:changed="approvalChanged"
    />
    <renewal-summary
      v-if="isRenewal"
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <pay-group-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <job-class-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <location-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <eligibility-group-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <eligibility-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <cobra-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <deduction-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <enroller-summary
      class="oe-summary-section"
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <template-summaries
      :expanded="expanded"
      :open-enrollment="openEnrollment"
      @approval:changed="approvalChanged"
    />
    <base-material-snackbar
      v-model="displayError"
      type="error"
      v-bind="{
        top: true,
        right: true
      }"
    >
      {{ errorMessage }}
    </base-material-snackbar>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'OpenEnrollmentSummary',

    components: {
      GroupSummary: () => import('./GroupSummary'),
      RenewalSummary: () => import('./RenewalSummary'),
      PayGroupSummary: () => import('./PayGroupSummary'),
      JobClassSummary: () => import('./JobClassSummary'),
      LocationSummary: () => import('./LocationSummary'),
      EligibilityGroupSummary: () => import('./EligibilityGroupSummary'),
      EligibilitySummary: () => import('./EligibilitySummary'),
      CobraSummary: () => import('./CobraSummary'),
      DeductionSummary: () => import('./DeductionSummary'),
      EnrollerSummary: () => import('./EnrollerSummary'),
      TemplateSummaries: () => import('./TemplateSummaries'),
    },

    props: {
      openEnrollment: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      errorMessage: null,
      displayError: false,
      formErrors: {},
      expanded: false,

      openEnrollmentResource: new TroodyApi('openEnrollment/'),
    }),

    computed: {
      isRenewal () {
        return (this.openEnrollment || {}).isRenewal
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.formErrors = {}
        this.loadSummary()
      },

      toggleExpanded () {
        this.expanded = !this.expanded
      },

      percentColor (value) {
        let color = 'red'
        if (value > 33 && value < 66) {
          color = 'orange'
        } else if (value >= 66 && value < 100) {
          color = 'amber'
        } else if (value >= 100) {
          color = 'green'
        }
        return color
      },

      loadSummary () {
        console.log('Load all summaries')
      },

      approvalChanged () {
        if (this.openEnrollment && this.openEnrollment.id) {
          this.openEnrollmentResource.get(this.openEnrollment.id)
            .then(data => {
              if (data) {
                this.openEnrollment.approvedPercent = data.approvedPercent
              }
            })
        }
      },

      showError (error, msg) {
        console.log(error)
        this.errorMessage = (error || msg)
        this.displayError = true
      },
    },
  }
</script>
<style lang="sass">
  .oe-summary-title
    text-align: center !important
    font-size: 1.5625rem !important
    font-weight: 400
    line-height: 1.4em
    letter-spacing: normal !important
    font-family: "Roboto", sans-serif !important

  .oe-summary-section
    border-left: 5px solid rgba(0, 0, 0, 0.6)
    border-top: 1px solid rgba(0, 0, 0, 0.6)
    border-radius: 10px
    padding-left: 5px
    margin-bottom: 25px

    .oe-summary-subsection
      border-right: 5px double rgba(0, 0, 0, 0.2)
      border-bottom: 1px dashed rgba(0, 0, 0, 0.2)
      border-radius: 10px
      background-color: rgba(199, 203, 199, 0.1)
      margin-left: -6px
      padding-left: 6px
      margin-right: -6px
      padding-right: 6px
</style>
